import React, { createContext, useState } from 'react';

const ActiveLinkContext = createContext();

const ActiveLinkProvider = ({ children }) => {
  const [activeLink, setActiveLink] = useState('home');

  return (
    <ActiveLinkContext.Provider value={{ activeLink, setActiveLink }}>
      {children}
    </ActiveLinkContext.Provider>
  );
};

export { ActiveLinkContext, ActiveLinkProvider };